import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

type Props = {
  code: string;
  codeName: string;
  useYn: "" | "true" | "false";
  size: number;

  onChangeQuery: (
    patch: Partial<{ code: string; codeName: string; useYn: boolean | undefined; size: number }>
  ) => void;
  onSearch: () => void;
  onReset: () => void;
  onCreate: () => void;

  disabled?: boolean; // 그룹 선택 안됐을 때
};

export default function CommonCodeFilterBar({
  code,
  codeName,
  useYn,
  size,
  onChangeQuery,
  onSearch,
  onReset,
  onCreate,
  disabled,
}: Props) {
  const [inputCode, setInputCode] = useState(code);
  const [inputCodeName, setInputCodeName] = useState(codeName);

  return (
    <Paper
      elevation={0}
      sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}
    >
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} alignItems="center">
        <TextField
          size="small"
          label="code"
          value={inputCode}
          onChange={(e) => setInputCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onChangeQuery({ code: inputCode, codeName: inputCodeName });
              onSearch();
            }
          }}
          sx={{ minWidth: 180 }}
          disabled={disabled}
        />
        <TextField
          size="small"
          label="codeName"
          value={inputCodeName}
          onChange={(e) => setInputCodeName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onChangeQuery({ code: inputCode, codeName: inputCodeName });
              onSearch();
            }
          }}
          sx={{ minWidth: 240, flex: 1 }}
          disabled={disabled}
        />

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="code-useYn-label">useYn</InputLabel>
          <Select
            labelId="code-useYn-label"
            label="useYn"
            value={useYn}
            onChange={(e) =>
              onChangeQuery({
                useYn: e.target.value === "" ? undefined : e.target.value === "true",
              })
            }
            disabled={disabled}
          >
            <MenuItem value="">전체</MenuItem>
            <MenuItem value="true">Y</MenuItem>
            <MenuItem value="false">N</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="code-size-label">size</InputLabel>
          <Select
            labelId="code-size-label"
            label="size"
            value={size}
            onChange={(e) => onChangeQuery({ size: Number(e.target.value) })}
            disabled={disabled}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>

        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            onClick={() => {
              onChangeQuery({ code: inputCode, codeName: inputCodeName });
              onSearch();
            }}
            disabled={disabled}
          >
            검색
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setInputCode("");
              setInputCodeName("");
              onReset();
            }}
            disabled={disabled}
          >
            초기화
          </Button>
        </Stack>

        <Button variant="contained" color="primary" onClick={onCreate} disabled={disabled}>
          + 코드 생성
        </Button>
      </Stack>
    </Paper>
  );
}
